module.exports = __webpack_public_path__ + "img/bar-icon.5dcb08ec.png";